<template>
  <div class="visit-calendar-schedule-update ">
    <div class="modal-dialog mt-0">
      <div class="modal-content border-0">
        <div class="modal-header px-4">
          <h5 class="modal-title">
            <div class="d-inline mr-1">
              <img class="pb-1" :src="titleIcon" />
            </div>
            Tiempo
          </h5>
        </div>
        <div class="modal-body px-4">
          <div class="px-2">
            <div class="mb-3">
              <span class="color-gray-6 font-14 font-weight-normal">
                Horario de Comienzo:
              </span>
              <validation-observer ref="startHourForm" v-slot="{ errors }">
                <div class="mt-2 d-flex inputs-row">
                  <div>
                    <validation-provider
                      name="hour"
                      :rules="`numeric|required|hour:${model.start.type}`"
                    >
                      <custom-input
                        v-model="model.start.hour"
                        class="calendar-available-space-input"
                        :class="{
                          'border border-danger rounded':
                            errors.hour?.length || isStartGreaterThan745,
                        }"
                        placeholder="0"
                        @change.native="onChangeStart"
                      />
                    </validation-provider>
                  </div>
                  <div class="mt-1 mx-1">
                    :
                  </div>
                  <div class="mr-1">
                    <validation-provider
                      name="minute"
                      rules="numeric|required|quater"
                    >
                      <custom-input
                        v-model="model.start.minute"
                        class="calendar-available-space-input"
                        :class="{
                          'border border-danger rounded':
                            errors.minute?.length || isStartGreaterThan745,
                        }"
                        placeholder="00"
                        @change.native="onChangeStart"
                      />
                    </validation-provider>
                  </div>
                  <div class="ml-1">
                    <select
                      v-model="model.start.type"
                      class="form-control px-1"
                      :class="{
                        'border border-danger rounded': isStartGreaterThan745,
                      }"
                      @change="onChangeStart"
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </div>
                <div class="row py-0 my-0">
                  <div
                    v-for="(error, key) in errors"
                    :key="key"
                    class="col-12 py-0 my-0 text-danger"
                  >
                    <span v-if="error[0] === 'Campo Requerido'">
                      El campo {{ parseErrorMessage(key) }} es requerido.
                    </span>
                    <span v-else>{{ parseErrorMessage(error[0]) }}</span>
                  </div>
                  <div
                    v-if="isStartGreaterThan745"
                    class="col-12 py-0 my-0 text-danger"
                  >
                    <span>
                      El horario seleccionado no es válido.
                    </span>
                  </div>
                </div>
              </validation-observer>
            </div>
            <div class="mb-3">
              <span class="color-gray-6 font-14 font-weight-normal">
                Horario de Finalización:
              </span>
              <div class="mt-2 d-flex inputs-row">
                <div>
                  <input
                    class="form-control"
                    :class="{
                      'border border-danger rounded': isEndGreaterThan8,
                    }"
                    disabled
                    placeholder="0"
                    :value="model.end.hour"
                  />
                </div>
                <div class="mt-1 mx-1">
                  :
                </div>
                <div class="mr-1">
                  <input
                    class="form-control"
                    :class="{
                      'border border-danger rounded': isEndGreaterThan8,
                    }"
                    disabled
                    placeholder="00"
                    :value="model.end.minute"
                  />
                </div>
                <div class="ml-1">
                  <input
                    class="form-control"
                    :class="{
                      'border border-danger rounded': isEndGreaterThan8,
                    }"
                    disabled
                    :value="model.end.type"
                  />
                </div>
              </div>
              <div v-if="isEndGreaterThan8" class="py-0 my-0 text-danger">
                <span>
                  El horario seleccionado no es válido.
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer pl-1">
          <action-button
            id="visit-calendar-schedule-update-cancel-btn"
            i="fa fa-times-circle"
            variant="outline-danger w-45"
            @click="cancel"
          >
            Cancelar
          </action-button>
          <action-button
            id="visit-calendar-schedule-update-save-btn"
            i="fa fa-save"
            variant="success w-45"
            @click="save"
          >
            Guardar
          </action-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import moment from 'moment';
import alertMixin from 'utils/mixins/alert.mixin.js';
import { equals } from '@/utils/objUtils';

const amHourSet = [7, 8, 9, 10, 11];
const pmHourSet = [12, 1, 2, 3, 4, 5, 6, 7, 8];
const format = 'h:mm A';
const TYPES = { visit: 0, schedule: 1 };
extend('hour', {
  validate: (value, { type }) => {
    const number = Number(value);
    if (type === 'AM') return amHourSet.includes(number);
    if (type === 'PM') return pmHourSet.includes(number);
    return true;
  },
});
extend('quater', {
  validate: (value) => value % 5 === 0,
  message: 'Valores permitidos en intervalos de 5 minutos.',
});
export default {
  name: 'VisitCalendarScheduleUpdate',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomInput,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          id: null,
          startDate: null,
          endDate: null,
        };
      },
    },
    day: {
      type: Number,
      default: () => 0,
    },
    duration: {
      type: Number,
      default: () => 0,
    },
    scheduleId: {
      type: Number,
      default: () => null,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {
        start: {
          hour: null,
          minute: null,
          type: 'AM',
        },
        end: {
          hour: null,
          minute: null,
          type: 'AM',
        },
      },
      initialModel: {
        start: {
          hour: null,
          minute: null,
          type: 'AM',
        },
        end: {
          hour: null,
          minute: null,
          type: 'AM',
        },
      },
    };
  },
  computed: {
    titleIcon() {
      return require('@/assets/img/white-clock.svg');
    },
    startHourValue() {
      const { hour, minute, type } = this.model.start;
      const time = `${hour}:${minute} ${type}`;
      return moment(time, format);
    },
    endHourValue() {
      const { hour, minute, type } = this.model.end;
      const time = `${hour}:${minute} ${type}`;
      return moment(time, format);
    },
    isStartGreaterThan745() {
      const start = moment('7:45 PM', format);
      return this.startHourValue.isAfter(start);
    },
    isEndGreaterThan8() {
      const endHour = moment('8:00 PM', format);
      return this.endHourValue.isAfter(endHour);
    },
    modelEqualsToInitialModel() {
      return equals(this.model, this.initialModel);
    },
  },
  async mounted() {
    this.model = this.setModelFromData();
    this.initialModel = this.setModelFromData();
  },
  methods: {
    onInputStartHour(input) {
      const isIvalidad = isNaN(input);
      if (isIvalidad) return;

      const value = Number(input);

      if ([7, 8].includes(value)) return;

      if (amHourSet.includes(value)) {
        this.model.start.type = 'AM';
        return;
      }
      if (pmHourSet.includes(value)) {
        this.model.start.type = 'PM';
        return;
      }
    },
    onInpuStartMinute(input) {
      const isIvalidad = isNaN(input);
      if (isIvalidad) return;

      const value = Number(input);

      if (value < 0) {
        this.model.start.minute = 0;
        return;
      }
      if (value > 45) {
        this.model.start.minute = 45;
        return;
      }
    },
    async onChangeStart() {
      this.onInputStartHour(this.model.start.hour);
      this.onInpuStartMinute(this.model.start.minute);
      const isValidStart = await this.$refs.startHourForm.validate();
      if (!isValidStart || this.isStartGreaterThan745) return;
      const { hour, minute, type } = this.model.start;
      const time = `${hour}:${minute} ${type}`;
      const start = moment(time, format);
      const end = start.add(this.duration, 'minutes');
      const endHour = Number(end.hour());
      this.model.end.hour = endHour <= 12 ? endHour : endHour - 12;
      this.model.end.minute =
        Number(end.minutes()) === 0 ? '00' : Number(end.minutes());
      this.model.end.type = endHour === 12 ? 'PM' : this.model.start.type;
    },
    parseErrorMessage(msg) {
      if (!msg) return '';
      return msg.replace('hour', 'hora').replace('minute', 'minuto');
    },
    setModelFromData() {
      let model = {
        start: {
          hour: 0,
          minute: 0,
          type: null,
        },
        end: {
          hour: 0,
          minute: 0,
          type: null,
        },
      };
      const start = moment(new Date(this.data.startDate));
      const startHour = Number(start.hour());
      model.start.hour = startHour <= 12 ? startHour : startHour - 12;
      model.start.minute =
        Number(start.minutes()) === 0 ? '00' : Number(start.minutes());
      model.start.type = startHour < 12 ? 'AM' : 'PM';

      const end = start.clone().add(this.duration, 'minutes');
      const endHour = Number(end.hour());
      model.end.hour = endHour <= 12 ? endHour : endHour - 12;
      model.end.minute =
        Number(end.minutes()) === 0 ? '00' : Number(end.minutes());
      model.end.type = endHour === 12 ? 'PM' : model.start.type;

      return model;
    },
    cancel() {
      this.$emit('cancel');
    },
    async save() {
      const isValidStart = await this.$refs.startHourForm.validate();
      const invalid =
        !isValidStart || this.isStartGreaterThan745 || this.isEndGreaterThan8;
      if (invalid) {
        this.ShowToast(
          'Error',
          'El horario seleccionado no es válido.',
          'error'
        );
        return;
      }
      if (this.modelEqualsToInitialModel) {
        this.ShowToast(
          'Error',
          'Debe cambiar la Hora de Comienzo para actualizar el horario de la visita.',
          'error'
        );
        return;
      }

      const startDate = this.startHourValue.format();
      const endDate = this.endHourValue.format();
      const { id, type } = this.data;
      let payload = {
        startDate,
        endDate,
        day: this.day,
        scheduleId: this.scheduleId,
      };
      if (type === TYPES.visit) payload.visitId = id;
      this.$emit('save', payload);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.visit-calendar-schedule-update > .modal-dialog {
  position: absolute;
  z-index: 2;
  width: 300px;
}
.visit-calendar-schedule-update .modal-header {
  box-shadow: 0px 3px 6px #00000029;
}
.visit-calendar-schedule-update .modal-footer {
  box-shadow: 0px 0px 3px #00000029 !important;
}
.visit-calendar-schedule-update .modal-content {
  box-shadow: 0px 2px 8px rgb(0 0 0 / 35%);
}

.visit-calendar-schedule-update .modal-title > div {
  padding: 1px 8px;
  border: 3px solid white;
  border-radius: 30px;
  box-shadow: 0px 3px 6px #00000029;
  background: map-get($colors, 'orange');
}

.inputs-row > div:first-child,
.inputs-row div:nth-child(3) {
  width: 50px;
}

.inputs-row > div:nth-child(4) {
  width: 60px;
}
</style>
